export interface Action {
  name: string;
  onAction(): void;
  askForConfirmationText?: string;
  inProgress?: boolean;
}

export interface DestructiveAction extends Action {
  description: string;
  askForConfirmationText: string;
  confirmationValue: string;
  redirectionURLAfterAction?: string;
}

export function isAction(action: any): action is Action {
  return !!action.name && !!action.onAction;
}

export function isDestructiveAction(action: any): action is DestructiveAction {
  return !!action.askForConfirmationText && isAction(action);
}
